// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"17967": "c1fc0782","18421": "81af5d06","20247": "fd2790bb","25981": "c1ae581b","42530": "81999d02","49481": "b72f50d2","89066": "47e4a6fa",}[chunkId] + ".css"
}